module.exports = __webpack_public_path__ + "img/dz_regular.2f1402fe.png";